import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    async get(filters) {
        let params = "";
        if (filters.size) {
            params += "?";
            filters.forEach((value, key) => {
                params += `${key}=${value}&`;
            });
            params.slice(0, -1);
        }
        return await http.get(buildUrlFromLocation(`/cf/period-has-components${params}`, { campaignId: null }));
    }
};



// WEBPACK FOOTER //
// ./src/services/cfPeriodHasComponents.js